import * as yup from 'yup'

const happyfoxChatFormValidationSchema = yup
  .object({
    apiKey: yup.string().trim().required('Api key is required').min(10, 'Invalid API Key')
  })
  .required()

export const selectProfileSchema = yup
  .object({
    profile: yup.string().required('Select a profile')
  })
  .required()

export default happyfoxChatFormValidationSchema
